import React from 'react'
import ReactPaginate from 'react-paginate'

import { StyledPagination } from './styles'

type Props = {
  onPageChange: (selectedItem: { selected: number }) => void
  pageCount: number
  pageRangeDisplayed?: number
  marginPagesDisplayed?: number
  currentPage: number
}

export const Pagination: React.FC<Props> = ({
  onPageChange,
  pageCount,
  pageRangeDisplayed = 3,
  marginPagesDisplayed = 3,
  currentPage,
}) => {
  return (
    <StyledPagination data-testid="pagination">
      <ReactPaginate
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        initialPage={currentPage - 1}
        containerClassName="pagination_container"
        pageClassName="pagination_page"
        activeClassName="pagination_active"
        forcePage={currentPage - 1}
        disableInitialCallback={true}
      />
    </StyledPagination>
  )
}
